module.exports = __webpack_public_path__ + "media/images/dummy-content/user-7-ac07e28491d0f240dd1cecb1eae9c92f.jpg";